const PUBLISHED_URL = "https://serafisio.com.br";
const configuredAppUrl = import.meta.env.VITE_APP_URL?.trim();

function normalizeUrl(url: string): string {
  return url.replace(/\/$/, "");
}

function isLocalhostUrl(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return ["localhost", "127.0.0.1", "0.0.0.0"].includes(parsedUrl.hostname);
  } catch {
    return false;
  }
}

function isLocalhostHostname(hostname: string): boolean {
  return ["localhost", "127.0.0.1", "0.0.0.0"].includes(hostname);
}

export function getAuthRedirectBaseUrl(): string {
  // If running on localhost, use localhost for dev convenience
  if (isLocalhostHostname(window.location.hostname)) {
    return normalizeUrl(window.location.origin);
  }

  // Always prefer configured URL or published URL for production
  if (configuredAppUrl) {
    const normalizedConfiguredUrl = normalizeUrl(configuredAppUrl);
    if (!isLocalhostUrl(normalizedConfiguredUrl)) {
      return normalizedConfiguredUrl;
    }
  }

  // Fallback to published URL to avoid preview/editor URLs in emails
  return PUBLISHED_URL;
}
